import {
    CompletedReleaseSummary,
    NextReleaseSummary,
    OrgOverviewApprovalItemDurations,
    OrgOverviewStatistic,
} from '../types';

export const FETCH_ORG_OVERVIEW_V2_SUCCESS = 'FETCH_ORG_OVERVIEW_V2_SUCCESS';

export interface OrgOverviewV2Response {
    id: string; // the unique id of the set whose data was requested. can be orgId, appGroupId, or appId
    singleAppId?: string; // the appId of the app that the data is for only avaliable asking for a specific app and not an org or appGroup, otherwise null
    liveRelease?: CompletedReleaseSummary; // only avaliable if the id is an appId
    nextRelease?: NextReleaseSummary; // only avaliable if the id is an appId
    statistics: OrgOverviewStatistic[];
    averageApprovalItemDurations?: OrgOverviewApprovalItemDurations;
}

export interface FetchOrgOverviewV2SuccessAction {
    type: typeof FETCH_ORG_OVERVIEW_V2_SUCCESS;
    payload: OrgOverviewV2Response;
}

export const fetchOrgOverviewV2Success: (payload: OrgOverviewV2Response) => FetchOrgOverviewV2SuccessAction = (
    payload,
) => {
    return {
        type: FETCH_ORG_OVERVIEW_V2_SUCCESS,
        payload,
    };
};
